import styled from "styled-components";

export const StyledDevices = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    padding: 0 24px;
`;

export const Header = styled.header`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    margin: 20px 0;
    gap: 24px;
`;
